import { ParamWithNestedParent } from '../../../../../shared/types/param';

export const initialValues: ParamWithNestedParent = {
    name: '',
    active: true,
    parent: '',
    nestedParent: '',
    nestedParent2: '',
    nestedParent3: '',
};
